import { fetchWithAuth } from './client';

export interface FieldInfo {
  name: string;
  type: string;
  kind: string;
  isList: boolean;
  isRelation: boolean;
  relationName?: string;
  relationFromFields?: string[];
  relationToFields?: string[];
}

export interface ModelInfo {
  name: string;
  fields: FieldInfo[];
}

export interface TableDataResponse {
  rows: Record<string, unknown>[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

export const schemaApi = {
  getSchema: () => fetchWithAuth<ApiResponse<ModelInfo[]>>('/schema'),

  getTableData: (
    tableName: string,
    params: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
      filters?: Record<string, string>;
    } = {}
  ) => {
    const searchParams = new URLSearchParams();
    if (params.page) {
      searchParams.set('page', String(params.page));
    }
    if (params.pageSize) {
      searchParams.set('pageSize', String(params.pageSize));
    }
    if (params.sortBy) {
      searchParams.set('sortBy', params.sortBy);
    }
    if (params.sortOrder) {
      searchParams.set('sortOrder', params.sortOrder);
    }
    if (params.filters && Object.keys(params.filters).length > 0) {
      searchParams.set('filters', JSON.stringify(params.filters));
    }

    const qs = searchParams.toString();
    return fetchWithAuth<ApiResponse<TableDataResponse>>(`/tables/${tableName}${qs ? `?${qs}` : ''}`);
  },

  deleteRows: (tableName: string, ids: (string | number)[]) =>
    fetchWithAuth<ApiResponse<{ deletedCount: number }>>(`/tables/${tableName}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids })
    }),

  updateRow: (tableName: string, id: string | number, data: Record<string, unknown>) =>
    fetchWithAuth<ApiResponse<Record<string, unknown>>>(`/tables/${tableName}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    })
};
